import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';
import { usePageTitle } from '../hooks/usePageTitle';
import { ProfilUnterseite } from '../components/profil/ProfilUnterseite';


const CONFIRM_WORD = 'LÖSCHEN';

const DeleteAccount: React.FC = () => {
  usePageTitle('Konto löschen');
  const navigate = useNavigate();
  const { deleteAccount } = useAuth();
  const [confirmText, setConfirmText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const canDelete = confirmText.trim().toUpperCase() === CONFIRM_WORD;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canDelete) return;

    setIsSubmitting(true);
    try {
      await deleteAccount();
      toast.success('Dein Konto wurde gelöscht.');
      navigate('/');
    } catch (error: any) {
      toast.error(error.message || 'Konto konnte nicht gelöscht werden');
      setIsSubmitting(false);
    }
  };

  return (
    <ProfilUnterseite titel="Konto löschen">
      <form className="pf-gruppe" onSubmit={handleSubmit}>
        <p className="pf-warnung">
          Dein Konto wird dauerhaft gelöscht, mit E-Mail, Name, Standort, vorgemerkten Events,
          Freunden und Benachrichtigungen. Eingereichte Event-Vorschläge bleiben anonym erhalten.{' '}
          <strong>Das lässt sich nicht rückgängig machen.</strong>
        </p>
        <label className="pf-feld">
          <span className="pf-feld-label">Zum Bestätigen „{CONFIRM_WORD}“ eingeben</span>
          <input className="pf-eingabe" type="text" value={confirmText} placeholder={CONFIRM_WORD}
            autoComplete="off" autoCapitalize="characters" disabled={isSubmitting}
            onChange={(e) => setConfirmText(e.target.value)} />
        </label>
        <button type="submit" className="pf-knopf pf-knopf--gefahr" disabled={!canDelete || isSubmitting}>
          {isSubmitting ? 'Wird gelöscht …' : 'Konto endgültig löschen'}
        </button>
      </form>
    </ProfilUnterseite>
  );
};

export default DeleteAccount;
